// extracted by mini-css-extract-plugin
module.exports = {"typefaceBold":"Text-module--typefaceBold--1DI0L"};